import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    影视分类: [
      { to: '/category/dianshiju', label: '电视剧' },
      { to: '/category/dianying', label: '电影' },
      { to: '/category/zongyi', label: '综艺' },
      { to: '/category/dongman', label: '动漫' },
      { to: '/category/jilupian', label: '纪录片' },
    ],
    关于我们: [
      { to: '/about', label: '品牌介绍' },
      { to: '/about', label: '联系我们' },
      { to: '/about', label: '用户口碑' },
    ],
    帮助支持: [
      { to: '/about', label: '常见问题' },
      { to: '/about', label: '使用指南' },
      { to: '/about', label: '意见反馈' },
    ],
  };

  return (
    <footer className="bg-secondary-950">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-2-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50">久久影视</span>
              </Link>
              <p className="text-foreground-400 text-sm leading-relaxed">
                久久影视同步最新电视剧更新与最新电影上映，影视更新快，新剧综艺抢先看，高清流畅不缓冲，追剧党首选。
              </p>
            </div>

            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h4 className="text-background-50 font-heading font-semibold text-sm mb-4">{title}</h4>
                <ul className="flex flex-col gap-2">
                  {links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.to}
                        className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="border-t border-foreground-800/30 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-xs">
              &copy; {currentYear} 久久影视 JiujiuYS.com 版权所有 | 京ICP备2023XXXXXX号
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-foreground-400 hover:text-background-50 transition-colors text-xs" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-foreground-400 hover:text-background-50 transition-colors text-xs" rel="nofollow">
                服务条款
              </a>
              <a href="#" className="text-foreground-400 hover:text-background-50 transition-colors text-xs" rel="nofollow">
                Cookie设置
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}